import { React, useState } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../assets/images/GROTrackTurquoise.png";
import Loading from "../views/Loading";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { useUserContext } from "../contexts/userContext";
import { getLogo } from "../utlis/themeHelpers";
import AdminHeader from "../components/AdminHeader";
import { useTranslation } from "../contexts/TranslationContext";

export default function PatientSearch() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dob, setDOB] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [staffId, setStaffId] = useState('');
  const [message, setMessage] = useState("");
  const [ready, setReady] = useState(true);
  const [searchResults, setSearchResults] = useState(null);
  const { isSalonApp, staff, isAdmin, staffId: loggedInStaffId } = useUserContext();
  const { translate } = useTranslation();

  const isPatientValid = () => {
    return true;
  };

  const searchPatient = () => {
    if (isPatientValid()) {
      setReady(false);
      fetch(`${process.env.REACT_APP_API}/patient/search`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
        body: JSON.stringify({
          firstName: firstName.trim(),
          lastName: lastName.trim(),
          dob: dob && dob !== "" ? moment(dob).format("YYYY-MM-DD") : "",
          phone: phone.trim(),
          email: email.trim().toLowerCase(),
          staff_id: isAdmin ? staffId : loggedInStaffId
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.success) {
            setSearchResults(response.patients);
          } else {
            setMessage(response.message);
          }
          setReady(true);
        })
        .catch((error) => {
          console.error(error);
          setMessage(translate('error_occurred'));
          setReady(true);
        });
    }
  };

  return (
    <>
      <main
        className={`container mx-auto flex flex-col p-4 text-text-2 ${ready ? "" : "hidden"
          }`}
      >
        <AdminHeader />

        <h1 className="mt-16 text-center text-xl">
           {isSalonApp ? translate('search_client') : translate('search_patient')}
        </h1>
        {message && <p className="mt-4 text-center text-red-600">{message}</p>}
        {searchResults ? (
          <>
            {searchResults.length > 0 ? (
              <section className="mt-16 grid gap-4 justify-center font-font-2">
                {searchResults.map((patient) => {
                  return (
                    <div key={patient.id} className="flex items-end">
                      <p className="w-96 p-2 bg-background-2 text-text-7 text-center rounded-sm flex items-baseline justify-evenly">
                        <span className="truncate">
                          {patient.firstName} {patient.lastName}
                        </span>
                        <span className="font-normal text-sm">
                          {translate('dob')}: {patient.dob}
                        </span>
                      </p>
                      <NavLink
                        to={`/patient/${patient.id}/consult/0/global/crown/hair_thinning`}
                        className="ml-8 px-8 py-1 bg-background-23 rounded-lg text-sm text-text-3 focus:outline-none"
                      >
                        {translate('select')}
                      </NavLink>
                    </div>
                  );
                })}
              </section>
            ) : (
              <h1 className="mt-16">
                {isSalonApp ? translate('no_clients_found') : translate('no_patients_found')}
              </h1>
            )}
            <button
              className="mt-16 mx-auto px-8 py-1 bg-background-23 rounded-lg text-text-3 focus:outline-none"
              onClick={() => {
                setSearchResults(null);
              }}
            >
              {translate('search_again')}
            </button>
          </>
        ) : (
          <form
            className="mx-auto mt-16 flex flex-col items-end"
            onSubmit={(event) => {
              event.preventDefault();
              searchPatient();
            }}
          >
            <label className="flex items-center">
              <p className="ml-2">{translate('first_name')}</p>
              <input
                type="text"
                className="ml-6 w-40 md:w-96 px-2 py-1 bg-background-2 text-text-2 text-center rounded-sm focus:outline-none"
                value={firstName}
                onChange={(event) => {
                  setFirstName(event.target.value);
                }}
              />
            </label>
            <label className="mt-4 flex items-center">
              <p className="ml-2">{translate('last_name')}</p>
              <input
                type="text"
                className="ml-6 w-40 md:w-96 px-2 py-1 bg-background-2 text-text-2 text-center rounded-sm focus:outline-none"
                value={lastName}
                onChange={(event) => {
                  setLastName(event.target.value);
                }}
              />
            </label>
            <label className="mt-4 ml-12 self-start flex items-center">
              <p className="ml-2.5">{translate('dob')}</p>
              {/* <input
                type="date"
                
                className="ml-6 w-40 px-2 py-1 bg-background-2 text-text-2 text-center rounded-sm focus:outline-none"
                value={dob}
                onChange={(event) => {
                  setDOB(event.target.value);
                }}
              /> */}
              <DatePicker
                dateFormat="MM/dd/yyyy"
                className="ml-6 w-40 px-2 py-1 bg-background-2 text-text-2 text-center rounded-sm focus:outline-none"
                selected={Date.parse(dob)}
                onChange={(date) => {
                  setDOB(date);
                  console.log(date);
                }}
              />
            </label>
            <label className="mt-4 flex items-center">
              <p className="ml-2">{translate('phone')}</p>
              <input
                type="text"
                className="ml-6 w-40 md:w-96 px-2 py-1 bg-background-2 text-text-2 text-center rounded-sm focus:outline-none"
                value={phone}
                onChange={(event) => {
                  setPhone(event.target.value);
                }}
              />
            </label>
            <label className="mt-4 flex items-center">
              <p className="ml-2">{translate('email')}</p>
              <input
                type="text"
                className="ml-6 w-40 md:w-96 px-2 py-1 bg-background-2 text-text-2 text-center rounded-sm focus:outline-none"
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
              />
            </label>
            {
              isAdmin && (
                <label className="mt-4 flex items-center">
                  <p className="ml-2">{translate('staff')}</p>
                  <select id="staff" value={staffId} onChange={(e) => setStaffId(e.target.value)} class="ml-6 text-base rounded-sm block w-40 md:w-96 py-2 px-2 bg-background-2 border-gray-600 placeholder-gray-400 text-text-2 focus:outline-none focus:border-blue-500">
                    <option selected value="">{translate('choose_a_staff_member')}</option>
                    {staff?.map((staff) => (
                      <option value={staff?.id} key={staff?.id}>{staff?.name}</option>
                    ))}
                  </select>
                </label>
              )
            }
            <input
              className="mt-16 px-8 py-1 bg-background-23 rounded-lg text-text-3 cursor-pointer focus:outline-none"
              type="submit"
              value={translate('search')}
            />
          </form>
        )}
      </main>
      <Loading
        message={`${isSalonApp ? translate('searching_for_clients') : translate('searching_for_patient')}`}
        ready={ready}
      />
    </>
  );
}
